import { Field } from 'api/tasks';
import {
  BooleanFieldFilter,
  BooleanFilterOperationType,
} from '../filters/boolean';
import { getFieldValue } from './get-field-value';
import type { FilterFunction } from './types';

export const boolean = (filter: BooleanFieldFilter): FilterFunction => {
  const value = getFieldValue<boolean>(filter.field as any as Field);

  switch (filter.type) {
    case BooleanFilterOperationType.IsEmpty:
    case BooleanFilterOperationType.IsFalse:
      return (record) => value(record) == null || value(record) === false;
    case BooleanFilterOperationType.IsNotEmpty:
    case BooleanFilterOperationType.IsTrue:
      return (record) => value(record) === true;

    default:
      return () => true;
  }
};
